import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";

import { Transition } from "@headlessui/react";

import { BiCalendarAlt } from "components/atoms/Icon/bi/BiCalendarAlt";

import "react-datepicker/dist/react-datepicker.css";

export default function TimeLineReport({
  title,
  description,
  disabled,
  timeStamp,
  setTimeStamp,
  type,
}) {
  const [selectedDate, setSelectedDate] = useState(timeStamp);
  const [hideTips, setHideTips] = useState(false);
  const changeDate = (value) => {
    setSelectedDate(value);

    if (value === null) {
      setTimeStamp(null);
    } else {
      setTimeStamp(value);
    }
  };

  useEffect(() => {
    setSelectedDate(timeStamp);
  }, [timeStamp]);

  return (
    <div
      className={`relative flex items-start justify-between ${
        type === "FYE" ? "text-[#FF5630]" : "text-bbc-brand-700"
      }`}
    >
      <div className="flex w-2/3">
        <BiCalendarAlt className="mr-1  mt-0.5" />
        <span className="inline-flex align-middle font-medium sm:whitespace-nowrap">
          {title}
        </span>
      </div>
      <DatePicker
        disabled={disabled}
        selected={selectedDate}
        onChange={(date) => changeDate(date)}
        placeholderText={"DD/ MM/ YYYY"}
        dateFormat="dd/MM/yyyy"
        wrapperClassName={"float-right "}
        className="w-full border-0 bg-transparent p-0 text-right focus:border-0 focus:ring-0"
      />
      {type === "FYE" && (
        <Transition
          show={!hideTips}
          enter="transition-opacity duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="shadow-bbc absolute right-5  top-10 z-10 rounded-lg bg-white p-6 text-sm text-bbc-gray before:absolute before:-top-2 before:right-0 before:h-0 before:w-0 before:border-l-[12px] before:border-r-[12px] before:border-b-[12px] before:border-transparent before:border-b-white">
            <p className="mb-2 font-medium">Input day</p>
            <p>{description}</p>
            <button
              className="float-right mt-6 text-bbc-brand-500"
              onClick={() => {
                // E.target.offsetParent.classList.add("hidden");
                setHideTips(true);
              }}
            >
              Got it
            </button>
          </div>
        </Transition>
      )}
    </div>
  );
}
